import { render, staticRenderFns } from "./CloneEventModal.vue?vue&type=template&id=16f79fbf&scoped=true&"
import script from "./CloneEventModal.vue?vue&type=script&lang=js&"
export * from "./CloneEventModal.vue?vue&type=script&lang=js&"
import style0 from "./CloneEventModal.vue?vue&type=style&index=0&id=16f79fbf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f79fbf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCheckbox,VSelect,VTextField})
